import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { ChevronRight as ChevronRightIcon } from "@material-ui/icons";
import { COLORS } from "../styles";

interface SidebarItemProps {
  primary: string;
  secondary: string;
  selected: boolean;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  primary,
  secondary,
  selected,
  onClick,
}) => {
  return (
    <ListItem
      button
      selected={selected}
      onClick={onClick}
      style={{
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        borderLeft: selected ? "4px solid #ff9800" : "4px solid transparent",
        backgroundColor: selected ? "#f5f5f5" : "transparent",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        if (!selected) {
          e.currentTarget.style.backgroundColor = "#fafafa";
        }
      }}
      onMouseLeave={(e) => {
        if (!selected) {
          e.currentTarget.style.backgroundColor = "transparent";
        }
      }}
    >
      <ListItemIcon style={{ minWidth: 32 }}>
        <ChevronRightIcon
          style={{
            color: selected ? "#ff9800" : COLORS.iconGray,
            fontSize: 20,
          }}
        />
      </ListItemIcon>
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{
          style: {
            fontSize: "14px",
            fontWeight: selected ? 600 : 500,
            color: selected ? COLORS.textDark : COLORS.textPrimary,
          },
        }}
        secondaryTypographyProps={{
          style: {
            fontSize: "12px",
            lineHeight: 1.4,
            marginTop: 4,
            color: COLORS.textSecondary,
          },
        }}
      />
    </ListItem>
  );
};

export default SidebarItem;
